import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getClientApi = createAsyncThunk('getclientStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingClientDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllClients`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(clientDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(clientDetailClear())
                message.error(error) 
            })
    }
)


export const updateClientStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateClientStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(clientstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetClientApiSlice = createSlice({
    name: 'Clientgetapi',
    initialState: {
        clientData: null,
        loadingclient: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingClientDetail: state => {
            state.loadingclient=true
            state.clientData=null
        },
        clientDetailResponse: (state, action)=>{
            state.clientData= action.payload
            state.loadingclient= false
        },
        clientDetailClear: (state)=>{
            state.clientData= null
            state.loadingclient= false
        },
        changeJobDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        clientstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const clientIndex = state.clientData.findIndex(c => c.id === id)
            if (clientIndex !== -1) {
                state.clientData[clientIndex].status = status
            }
            state.loadingclient = false
        }
    },
})
export const { 
    gettingClientDetail, clientDetailResponse, clientDetailClear,
    changeJobDetailFilters, setPages, clientstatusResponse
} = GetClientApiSlice.actions;
export default GetClientApiSlice.reducer;